// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.57995 2H1V3C1 6.99781 2.17402 10.7245 4.1964 13.8503C5.73668 16.2311 7.76894 18.2633 10.1497 19.8036C13.2755 21.826 17.0022 23 21 23H22V14.4201L15.3094 12.9332L13.4504 14.7922C11.7492 13.7006 10.2994 12.2508 9.2078 10.5496L11.0668 8.69061L9.57995 2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.6048 2.40043L16.1862 2.28394L16.1432 4.28347L18.262 4.32903L14.9688 7.62225L16.383 9.03647L19.6762 5.74323L19.7218 7.862L21.7213 7.819L21.6048 2.40043Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-call-forwarded-filled')
export default class CallForwardedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'call-forwarded-filled',
    }
  }
}
